<template>
  <template v-if="isButtonVisible">
    <Button
      ref="networkButton"
      class="network-button"
      role="button"
      type="button"
      @click="toggleMenu"
    >
      <i :class="`${currentNetwork.toLocaleLowerCase()}-network-icon`" />
      <span class="network">
        <span class="network__network">Network</span>
        <span class="network__title">
          {{ currentNetwork }}
        </span>
      </span>
      <i :class="{ rotate: showNetworkList }" class="check" />
    </Button>
  </template>
  <NetworkList
    v-if="showNetworkList || isMobileMenu"
    ref="networkMenu"
    :is-mobile-menu="isMobileMenu"
    :network-list="networkList"
  />
</template>

<script lang="ts" setup>
import { onClickOutside, useWindowSize } from "@vueuse/core";
import { computed, ref, toRefs } from "vue";
import { NetworkList } from "./NetworkList";
import { FullUrl } from "../../constants/urls";

type IProps = {
  isMobileMenu?: boolean;
  correctChainId: number;
};

const props = withDefaults(defineProps<IProps>(), {
  isMobileMenu: false,
});

const { isMobileMenu } = toRefs(props);

const { width } = useWindowSize();

const currentNetwork = computed(() => {
  switch (props.correctChainId) {
    case 1:
      return "Aptos";
    case 5:
      return "Lumio";
    case 27:
      return "Movement";
    case 177:
      return "Movement";
    case 126:
      return "Movement";
    default:
      return "Aptos";
  }
});

const showNetworkList = ref(false);
const networkMenu = ref<HTMLDivElement>();
const networkButton = ref<HTMLButtonElement>();
const networkList = ref([
  {
    label: "Aptos",
    active: currentNetwork.value === "Aptos",
    icon: "aptos-network-icon",
    href: FullUrl.LiquidSwap,
    visible: true,
  },
  {
    label: "Lumio",
    active: currentNetwork.value === "Lumio",
    icon: "lumio-network-icon",
    href: FullUrl.Lumio,
    visible: true,
  },
  {
    label: "Movement",
    active: currentNetwork.value === "Movement",
    icon: "movement-network-icon",
    href: FullUrl.Movement,
    visible: true,
  },
]);

const isButtonVisible = computed(
  () => width.value >= 390 && !isMobileMenu.value
);

function hideDropdown() {
  showNetworkList.value = false;
}

function toggleMenu() {
  showNetworkList.value = !showNetworkList.value;
}

onClickOutside(
  networkMenu,
  () => {
    hideDropdown();
  },
  {
    event: "click",
    capture: true,
    ignore: [networkButton],
  }
);
</script>

<style lang="scss" scoped>
.network-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 120px;
  height: 40px;
  border-radius: 100px;
  border: 1px solid #1c1c33;
  background: #14142f;
  padding: 8px;
  margin-left: 8px;
  cursor: pointer;

  @media screen and (max-width: 390px) {
    display: none;
  }
}

.check {
  width: 10px;
  height: 6px;
  margin-left: 0.25rem;
  mask: no-repeat center/contain url("./../../assets/angle.svg");
  background-color: #d4c4ed;
  transition: transform 0.15s ease;
  will-change: transform, background-color;

  &.rotate {
    transform: rotate(180deg);
  }
}

.network {
  display: flex;
  flex-direction: column;

  &__network {
    color: #9594aa;
    font-family: var(--font-family);
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.3px;
  }
  &__title {
    color: var(--Text-Primary, #e5e4fa);
    font-size: 12px;
  }
}
.aptos-network-icon {
  width: 24px;
  height: 24px;
  background-image: url("../../assets/tokens/apt.svg");
}
.movement-network-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  height: 24px;
  width: 24px;
  background: #03031b;
  position: relative;

  &::after {
    content: "";
    background: url("../../assets/logo/movement.svg") no-repeat center;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    z-index: 2;
    display: block;
  }
}

.lumio-network-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  height: 24px;
  width: 24px;
  background: #03031b;
  position: relative;

  &::after {
    content: "";
    background: url("../../assets/logo/lumio.svg") no-repeat;
    width: 14px;
    height: 14px;
    z-index: 2;
    display: block;
  }
}
</style>
